var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"xs12":"","sm6":"","d-flex":""}},[_c('v-select',{attrs:{"items":_vm.ordinations,"label":"Ordenação","item-text":"title","item-value":"business","return-object":"","prepend-icon":"swap_vert"},model:{value:(_vm.ordination),callback:function ($$v) {_vm.ordination=$$v},expression:"ordination"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }